// extracted by mini-css-extract-plugin
export default {"container":"style_container__LWhQ8","cardContent":"style_cardContent__V7BQr","description":"style_description__2EcdT","addCartBtn":"style_addCartBtn__4hNpa"};